import React from "react";
import styled from "styled-components";

const StyledIcon = styled.i`
  padding: 0px;
  font-size: 16px;
  padding-left: 3px;
`;

const QuestionIcon = () => <StyledIcon className="la la-question-circle" />;

export default QuestionIcon;
